import { render, staticRenderFns } from "./LotsImport.vue?vue&type=template&id=90770570&"
import script from "./LotsImport.vue?vue&type=script&lang=js&"
export * from "./LotsImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports